import React from "react";
import { LuCheck } from "react-icons/lu";
import { cn } from "../../components/ui";

interface OptionCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  selected: boolean;
  onClick: () => void;
}

/** Opção marcável dos passos do recurso: título, detalhe e o círculo de seleção à direita. */
export const OptionCard: React.FC<OptionCardProps> = ({ title, description, selected, onClick }) => (
  <button
    type="button"
    aria-pressed={selected}
    onClick={onClick}
    className={cn(
      "relative flex min-h-14 w-full flex-col gap-0.5 rounded-control border-strong py-3.5 pl-4 pr-12 text-left transition-colors duration-fast",
      "focus-visible:outline-none focus-visible:shadow-focus",
      selected ? "border-primary bg-primary-selected" : "border-line bg-surface hover:border-primary-line"
    )}
  >
    <strong className="break-words text-body font-semibold">{title}</strong>
    {description && <span className="break-words text-caption text-fg-muted">{description}</span>}
    <span
      aria-hidden
      className={cn(
        "absolute right-3.5 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full border-2",
        selected ? "border-primary bg-primary text-on-primary" : "border-primary-line bg-surface text-transparent"
      )}
    >
      <LuCheck size={14} strokeWidth={3} />
    </span>
  </button>
);
